const initialState = {
    user: {
        
    },
    messages: [],
    inbox: []
}

export default function chat(state = initialState, action) {
    switch(action.type) {

        case 'SEND_MESSAGE':
            return {
                ...state,
                messages: [...action.payload, ...state.messages]
            }

        case 'SET_INBOX':
            return {
                ...state,
                inbox: action.payload
            }    

        default:
            return state    
    }
}